import { FC } from 'react';
import { CallsView } from './calls-view';

export const CallsPanel: FC = () => (
  <>
    <div className="pt-7">
      <CallsView />
    </div>
  </>
);
